import { Component, inject, Input, signal } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'acl-confirm-modal',
  standalone: false,
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent {
  private readonly modalController = inject(ModalController);
  readonly _title = signal<string>('');
  readonly _message = signal<string>('');

  @Input() set title(value: string) {
    this._title.set(value);
  }
  @Input() set message(value: string) {
    this._message.set(value);
  }

  async dismissYes(): Promise<void> {
    this.modalController.dismiss('yes');
  }

  async dismissNo(): Promise<void> {
    this.modalController.dismiss('no');
  }
}
